import React from 'react';

const EmptyJob = () => {
  return (
    <div className='text-center py-5 text-zinc-500 text-2xl text-mono'>
      <h2>Sorry ! No Job Found</h2>
    </div>
  );
};

export default EmptyJob;